import { useLocation } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { postAuthorizedJSON } from "../lib/fetch";

export const useRunCalc = ({ client }: { client: string }) => {
  const location = useLocation();
  let actionExecutionPage = "unknown";
  if (location.pathname.split("/")[1] == "dashboard") {
    actionExecutionPage = "dashboard";
  } else if (location.pathname.split("/")[3]) {
    actionExecutionPage = location.pathname.split("/")[3];
  }

  const mutation = useMutation({
    mutationFn: async () => {
      const response = await postAuthorizedJSON(
        `${import.meta.env.VITE_BACKEND_URL}/${client}/run-calc`,
        {
          prefix: client,
          action_button_name: "Relancer les calculs",
          action_execution_page: actionExecutionPage,
        },
      );
      return response;
    },
    onSuccess: () => {
      toast.success("Calculs lancés avec succès");
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.detail || "Erreur lors du lancement des calculs";

      toast.error(errorMessage);
      console.error("Erreur lors du lancement des calculs:", error);
    },
  });

  return mutation;
};
